module.exports = __webpack_public_path__ + "static/avatar-27fc31cbedcd2bdb5ba85c43b1d82b22.jpg";